import { ChangeDetectorRef, Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISystemModule } from 'src/app/domain/registration/models/ISystemModule';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { SystemModuleCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { SystemModuleService } from '../crud-service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import moment from 'moment';

@Component({
  selector: 'app-system-module-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemModuleService],
})
export class SystemModuleCrudIndex
  extends AbstractCrudIndex<ISystemModule>
  implements ITableResponsive
{
  override title = 'MODULO DE SISTEMA';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;
  public filterFormValues: any = null
  userType: string = '';
  currentTab: string = 'system-modules';
  constructor(
    public override dialog: MatDialog,
    public override service: SystemModuleService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService,
    public permissionService: PermissionService,
  ) {
    super(dialog, service, toastService, mediaObserver, router);

    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'system-modules';

    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;

      this.dataSource = new MatTableDataSource<any>(
        data.map((item: any) => {
          item['system'] = item.system?.name;
          item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
          item['hideEdit'] = !item.allowEdit;
          item['hideDelete'] = !item.allowDelete;
          return item;
        })
      );
    });
  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemModuleCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemModuleCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      callBack: (data: any) => {
        if (data?.element) {
          this.service.create(Object.assign({}, data.element)).subscribe(
            () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
            },
            (error) => {
              this.openNew(data.element);
            }
          );
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemModuleCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      callBack: (data: any) => {
        if (data?.element?.id) {
          this.service.update(data?.element?.id, Object.assign({}, data?.element)).subscribe({
            next: () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
            },
            error: (error) => {
              this.openEdit(data.element);
            },
          });
        }

        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }
  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };


    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }
}
